import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IGraphCollectionsType } from '../model/dto/graph-collections.type';

export interface IAppState {
    selectedAssetTimezone: string | null;
    selectedGraphCollectionsType: IGraphCollectionsType | null;
}

@Injectable({
    providedIn: 'root',
})
export class AppStateService {
    private appState: BehaviorSubject<IAppState>;

    constructor() {
        this.appState = new BehaviorSubject<IAppState>({
            selectedAssetTimezone: null,
            selectedGraphCollectionsType: null,
        });
    }

    public getSelectedTimezone(): string {
        const timeZone: string | null = this.appState.getValue().selectedAssetTimezone;

        if (timeZone) {
            return timeZone;
        } else {
            return localStorage.getItem('appTimezone') ?? 'UTC';
        }
    }

    public setSelectedAssetTimezone(timezone: string): void {
        if (this.getSelectedTimezone() !== timezone) {
            const newState: IAppState = {
                ...this.appState.getValue(),
                selectedAssetTimezone: timezone,
            };

            this.appState.next(newState);
            localStorage.setItem('appTimezone', timezone);
        }
    }

    public getSelectedGraphCollectionsType(): IGraphCollectionsType | null {
        // Can be changed to selectedGraphId ?
        return this.appState.getValue().selectedGraphCollectionsType;
    }

    public setSelectedGraphCollectionsType(value: IGraphCollectionsType): void {
        const newState: IAppState = {
            ...this.appState.getValue(),
            selectedGraphCollectionsType: value,
        };

        this.appState.next(newState);
    }
}
